export default "__VITE_ASSET__YCwNTENC__"